import React, { useState } from "react";

import { Avatar, CardHeader, IconButton, Tooltip } from "@material-ui/core";
import HistoryIcon from "@material-ui/icons/History";

import { i18n } from "../../translate/i18n";
import TicketHistoryModal from "../TicketHistoryModal";

const TicketInfo = ({ contact, ticket, onClick }) => {
	const [historyOpen, setHistoryOpen] = useState(false);

	const handleHistoryOpen = (event) => {
		event.stopPropagation();
		setHistoryOpen(true);
	};

	const handleHistoryClose = () => {
		setHistoryOpen(false);
	};

	return (
		<>
			<CardHeader
				onClick={onClick}
				style={{ cursor: "pointer" }}
				titleTypographyProps={{ noWrap: true }}
				subheaderTypographyProps={{ noWrap: true }}
				avatar={<Avatar src={contact.profilePicUrl} alt="contact_image" />}
				action={
					<Tooltip title={i18n.t("ticketHistory.tooltip")}>
						<IconButton
							aria-label={i18n.t("ticketHistory.tooltip")}
							onClick={handleHistoryOpen}
						>
							<HistoryIcon />
						</IconButton>
					</Tooltip>
				}
				title={`${contact.name} #${ticket.id}`}
				subheader={
					ticket.user &&
						`${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`
				}
			/>
			<TicketHistoryModal
				open={historyOpen}
				handleClose={handleHistoryClose}
				ticketId={ticket.id}
			/>
		</>
	);
};

export default TicketInfo;
